import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, Routes, useParams, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../core/common/imageWithBasePath";
import { all_routes } from "./router/all_routes";
import Header from "./Header";
import { ProductContext } from "../context/AppContext";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Spinner } from "react-bootstrap";

const StudentProfileView = () => {
  const params = useParams();
  const routes = all_routes;
  const navigate = useNavigate();
  const {GetstudentData, session } = useContext(ProductContext);
const [isDownloading, setIsDownloading] = useState(false);


const sessionLabel = session?.find(
  (item) => item.value === GetstudentData?.session
)?.label;

 const handleDownloadPDF = async () => {
  try {
    setIsDownloading(true); // show loader
    const button = document.querySelector(".no-print");
    const input = document.getElementById("enquiry-content");

    // Hide download button before capture
    button.style.display = "none";

    // Wait a short delay to ensure all images/text are loaded
    await new Promise((resolve) => setTimeout(resolve, 1000));

    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true, // ensures images from URLs are captured properly
      logging: false,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`Admission_${GetstudentData?.student_full_name || "Data"}.pdf`);

    // Restore button after download
    button.style.display = "inline-block";
  } catch (error) {
    console.error("PDF generation error:", error);
  } finally {
    setIsDownloading(false); // hide loader
  }
};

  return (
    <>
      <div className="page-wrapper">
         <Header />
        {GetstudentData ? (
          <div className="content">
           
            <div className="row">
              <div className="col-md-12">
                <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                  <div className="my-auto mb-1 mt-3" style={{width:'100%'}}>
                    <h3 className="page-title mb-1">Student Details
                        {/* <span style={{float:'right'}}>
                            <Link
                              to=""
                              className="btn btn-primary no-print"
                              onClick={handleDownloadPDF}
                              disabled={isDownloading}
                            >
                              {isDownloading ? (
                                <>
                                  <i className="fa fa-spinner fa-spin me-2"></i> Downloading...
                                </>
                              ) : (
                                "Download"
                              )}
                            </Link>
                        </span> */}
                    </h3>
                  </div>
                </div>
              </div>
              {/* </div>
          <div className="row"> */}
              {/* Student Information */}
              <div id="enquiry-content">
                <div className="row">
              <div className="col-xxl-3 col-xl-4 theiaStickySidebar">
                <div className="stickybar pb-4">
                  <div className="card border-white">
                    <div className="card-header">
                      <div className="row">
                        <div className="col-xxl-4 col-xl-5 col-md-6">

                          <img
  src={GetstudentData?.upload_photo?.link}
  onError={(e) => {
    e.target.src =
      "assets/img/student.jfif";
  }}
  className="img-fluid rounded Parent_image"
  alt="Guardian"
/>

                          {/* {GetstudentData?.upload_photo ? (
                            <img
                              src={GetstudentData?.upload_photo?.link}
                              className="img-fluid rounded Parent_image"
                              alt="img"
                            />
                          ) : (
                            <ImageWithBasePath
                                    src="assets/img/student.jfif"
                                    className="img-fluid Parent_image"
                                    alt="img"
                                  />
                          )} */}
                        </div>
                        <div className="col-xxl-8 col-xl-7 col-md-6  pl-0">
                          <h5 className="mb-1 text-truncate text-truncate_1">
                            {GetstudentData?.student_full_name}
                          </h5>
                          <p className="Registration_Fee">
                                Roll No. : {GetstudentData?.roll_num}
                              </p>
                              <p className="Registration_Fee">
                                Class : {GetstudentData?.cls_sec?.cls?.Classes}{' '}
                          {GetstudentData?.cls_sec?.section?.section}
                              </p>
                        </div>
                      </div>
                    </div>
                    {/* Basic Information */}
                    <div className="card-body">
                      <h5 className="mb-3">Student Information</h5>
                      <dl className="row mb-0">
                        <dt className="col-6 fw-medium text-dark mb-3">
                          Session
                        </dt>
                        <dd className="col-6 mb-3">
                          {GetstudentData?.session_data?.Name || sessionLabel || "-"}
                        </dd>
                        <dt className="col-6 fw-medium text-dark mb-3">
                          User Id 
                        </dt>
                        <dd className="col-6 mb-3">
                          {GetstudentData?.id}
                        </dd>
                        <dt className="col-6 fw-medium text-dark mb-3">
                          Registration Id
                        </dt>
                        <dd className="col-6 mb-3">{GetstudentData?.regs_id}</dd>
                        <dt className="col-6 fw-medium text-dark mb-3">Admission No.</dt>
                        <dd className="col-6 mb-3">
                          {GetstudentData?.admission_num}
                        </dd>
                        <dt className="col-6 fw-medium text-dark mb-3">Admission Date</dt>
                        <dd className="col-6 mb-3">
                          {GetstudentData?.admission_date
                        ? new Date(GetstudentData?.admission_date)
                            .toISOString()
                            .split('T')[0]
                        : 'N/A'}
                        </dd>
                        <dt className="col-6 fw-medium text-dark mb-3">Date Of Birth</dt>
                        <dd className="col-6 mb-3">
                          {GetstudentData?.date_of_birth
                        ? new Date(GetstudentData?.date_of_birth)
                            .toISOString()
                            .split('T')[0]
                        : 'N/A'}
                        </dd>
                        {/* <dt className="col-6 fw-medium text-dark mb-3">
                          Aadhar No.
                        </dt>
                        <dd className="col-6 mb-3">
                          {GetstudentData?.aadhar_no}
                        </dd> */}
                        <dt className="col-6 fw-medium text-dark mb-3">
  Aadhar No.
</dt>
<dd className="col-6 mb-3">
  {GetstudentData?.aadhar_no
    ? GetstudentData.aadhar_no.replace(/\d(?=\d{4})/g, "X")
    : ""}
</dd>
                        <dt className="col-6 fw-medium text-dark mb-3">
                          Religion
                        </dt>
                        <dd className="col-6 mb-3">
                          {GetstudentData?.region?.name}
                        </dd>
                        {/* <dt className="col-6 fw-medium text-dark mb-3">Caste</dt>
                        <dd className="col-6 mb-3">
                          {GetstudentData?.cast?.category}
                        </dd> */}

                        <dt className="col-6 fw-medium text-dark mb-3">
                          Gender
                        </dt>
                        <dd className="col-6 mb-3">
                          {GetstudentData?.gender}
                        </dd>
                        
                      </dl>
                    </div>
                    {/* /Basic Information */}
                  </div>
                </div>
              </div>
              {/* /Student Information */}
              <div className="col-xxl-9 col-xl-8">
                <div className="row">
                  <div className="col-md-12">
                    {/* Parents Information */}
                    {GetstudentData?.father_full_name || 
           GetstudentData?.father_mobile_no ||
           GetstudentData?.father_qualification ||
           GetstudentData?.father_email ||
           GetstudentData?.father_aadhar_no ||
           GetstudentData?.father_date_of_birth ||
           GetstudentData?.father_occupation ? (
                    <div className="card">
                      <div className="card-header">
                        <h5>Father Details</h5>
                      </div>
                      <div className="card-body">
                        <div className="border rounded p-3 pb-0 mb-3">
                          <div className="row">
                            <div className="col-sm-6 col-lg-2">
                              <div className="d-flex align-items-center mb-3">
                                <img
  src={GetstudentData?.father_photo?.link}
  onError={(e) => {
    e.target.src =
      "assets/img/father.jfif";
  }}
  className="img-fluid rounded Parent_image"
  alt="Guardian"
/>

                                {/* {GetstudentData?.father_photo ? (
                                  <img
                                    src={GetstudentData?.father_photo?.link}
                                    className="img-fluid rounded Parent_image"
                                    alt="img"
                                  />
                                ) : (
                                  <ImageWithBasePath
                                    src="assets/img/father.jfif"
                                    className="img-fluid Parent_image"
                                    alt="img"
                                  />
                                )} */}
                              </div>
                            </div>
                            <div className="col-sm-6 col-lg-10">
                              <div className="row">
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Name
                                    </p>
                                    {GetstudentData?.father_full_name }
                                    <p className="text-primary">Father</p>
                                  </div>
                                </div>
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Phone
                                    </p>
                                    {GetstudentData?.father_mobile_no ? (
                                      <p>
                                        {
                                          GetstudentData
                                            ?.father_mobile_no
                                        }
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-12 col-sm-6 col-lg-4">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="mb-3 overflow-hidden me-3">
                                      <p className="text-dark fw-medium mb-1">
                                        Email
                                      </p>
                                      {GetstudentData?.father_email ? (
                                        <p className="text-truncate">
                                          {GetstudentData?.father_email}
                                        </p>
                                      ) : (
                                        <p className="text-truncate">N/A</p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                {/* </div>
                        <div className="row"> */}
                                <div className="col-6  col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <h6 className="text-dark fw-medium mb-1">
                                      Aadhar No.
                                    </h6>
                                    {GetstudentData?.father_aadhar_no ? (
                                      <p>
                                        {GetstudentData?.father_aadhar_no
    ? GetstudentData.father_aadhar_no.replace(/\d(?=\d{4})/g, "X")
    : ""}
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}

                                    
                                  </div>
                                </div>
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Qualification
                                    </p>
                                    {GetstudentData
                                      ?.father_qualification ? (
                                      <p>
                                        {
                                          GetstudentData
                                            ?.father_qualification
                                        }
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="mb-3 overflow-hidden me-3">
                                      <p className="text-dark fw-medium mb-1">
                                        Occupation
                                      </p>
                                      {GetstudentData
                                        ?.father_occupation ? (
                                        <p>
                                          {
                                            GetstudentData
                                              ?.father_occupation
                                          }
                                        </p>
                                      ) : (
                                        <p>N/A</p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                {/* </div>
                        <div className="row"> */}
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <h6 className="text-dark fw-medium mb-1">
                                      Company Name
                                    </h6>
                                    {GetstudentData
                                      ?.father_company_name ? (
                                      <p>
                                        {
                                          GetstudentData
                                            ?.father_company_name
                                        }
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Company Address
                                    </p>
                                    {GetstudentData
                                      ?.father_company_address ? (
                                      <p>
                                        {
                                          GetstudentData
                                            ?.father_company_address
                                        }
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
           ) : null}
                    {/* /Parents Information */}
                    {/* Mother Information */}
                    {GetstudentData?.mother_full_name || 
           GetstudentData?.mother_mobile_no ||
           GetstudentData?.mother_qualification ||
           GetstudentData?.mother_email ||
           GetstudentData?.mother_aadhar_no ||
           GetstudentData?.mother_date_of_birth ||
           GetstudentData?.mother_occupation ? (
                    <div className="card">
                      <div className="card-header">
                        <h5>Mother Details</h5>
                      </div>
                      <div className="card-body">
                        <div className="border rounded p-3 pb-0 mb-3">
                          <div className="row">
                            <div className="col-sm-6 col-lg-2">
                              <div className="d-flex align-items-center mb-3">

                                <img
  src={GetstudentData?.mother_photo_upload?.link}
  onError={(e) => {
    e.target.src =
      "assets/img/mother.jfif";
  }}
  className="img-fluid rounded Parent_image"
  alt="Guardian"
/>
                                
                                {/* {GetstudentData?.mother_photo_upload ? (
                                  <img
                                    src={
                                      GetstudentData?.mother_photo_upload?.link
                                    }
                                    className="img-fluid rounded Parent_image"
                                    alt="img"
                                  />
                                ) : (
                                  <ImageWithBasePath
                                    src="assets/img/mother.jfif"
                                    className="img-fluid Parent_image"
                                    alt="img"
                                  />
                                )} */}
                              </div>
                            </div>
                            <div className="col-sm-6 col-lg-10">
                              <div className="row">
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Name
                                    </p>
                                    {GetstudentData?.mother_full_name}
                                    <p className="text-primary">Mother</p>
                                  </div>
                                </div>
                                 {GetstudentData?.mother_mobile_no && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Phone
                                    </p>
                                    {GetstudentData?.mother_mobile_no ? (
                                      <p>
                                        {
                                          GetstudentData
                                            ?.mother_mobile_no
                                        }
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                 )}
                                 {GetstudentData?.mother_email && (
                                <div className="col-12 col-sm-6 col-lg-4">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="mb-3 overflow-hidden me-3">
                                      <p className="text-dark fw-medium mb-1">
                                        Email
                                      </p>
                                      {GetstudentData?.mother_email ? (
                                        <p className="text-truncate">
                                          {GetstudentData?.mother_email}
                                        </p>
                                      ) : (
                                        <p className="text-truncate">N/A</p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                 )}
                                 {GetstudentData?.mother_aadhar_no && (
                                <div className="col-6  col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <h6 className="text-dark fw-medium mb-1">
                                      Aadhar No.
                                    </h6>
                                    {GetstudentData?.mother_aadhar_no ? (
                                      <p>
                                        {GetstudentData?.mother_aadhar_no
    ? GetstudentData.mother_aadhar_no.replace(/\d(?=\d{4})/g, "X")
    : ""}
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                 )}
                                 {GetstudentData?.mother_qualification && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Qualification
                                    </p>
                                    {GetstudentData?.mother_qualification ? (
                                      <p>
                                        {
                                          GetstudentData
                                            ?.mother_qualification
                                        }
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                 )}
                                 {GetstudentData?.mother_occupation && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="mb-3 overflow-hidden me-3">
                                      <p className="text-dark fw-medium mb-1">
                                        Occupation
                                      </p>
                                      {GetstudentData?.mother_occupation ? (
                                        <p>
                                          {
                                            GetstudentData
                                              ?.mother_occupation
                                          }
                                        </p>
                                      ) : (
                                        <p>N/A</p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                 )}
                                 {GetstudentData?.mother_company_name && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <h6 className="text-dark fw-medium mb-1">
                                      Company Name
                                    </h6>
                                    {GetstudentData
                                      ?.mother_company_name ? (
                                      <p>
                                        {GetstudentData?.mother_company_name}
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                 )}
                                 {GetstudentData?.mother_company_address && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Company Address
                                    </p>
                                    {GetstudentData
                                      ?.mother_company_address ? (
                                      <p>
                                        {GetstudentData?.mother_company_address}
                                      </p>
                                    ) : (
                                      <p>N/A</p>
                                    )}
                                  </div>
                                </div>
                                 )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                                ) : null}
                    {/* /Mother Information */}
                    {/* Guardian Information */}
                    {GetstudentData?.guardian_name || 
           GetstudentData?.guardian_mobile_no ||
           GetstudentData?.guardian_qualification ||
           GetstudentData?.guardian_aadhar_no ||
           GetstudentData?.guardian_date_of_birth ? (
                    <div className="card">
                      <div className="card-header">
                        <h5>Guardian Details</h5>
                      </div>
                      <div className="card-body">
                        <div className="border rounded p-3 pb-0 mb-3">
                          <div className="row">
                            <div className="col-sm-6 col-lg-2">
                              <div className="d-flex align-items-center mb-3">
                                <img
  src={GetstudentData?.upload_guardian_photo?.link}
  onError={(e) => {
    e.target.src =
      "assets/img/father.jfif";
  }}
  className="img-fluid rounded Parent_image"
  alt="Guardian"
/>
                                {/* {GetstudentData
                                  ?.upload_guardian_photo ? (
                                  <img
                                    src={
                                      GetstudentData
                                        ?.upload_guardian_photo?.link
                                    }
                                    className="img-fluid rounded Parent_image"
                                    alt="img"
                                  />
                                ) : (
                                  <ImageWithBasePath
                                    src="assets/img/father.jfif"
                                    className="img-fluid Parent_image"
                                    alt="img"
                                  />
                                )} */}
                              </div>
                            </div>

                            <div className="col-sm-6 col-lg-10">
                              <div className="row">
                                {GetstudentData?.guardian_name && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <h6 className="text-truncate">
                                      <p className="text-dark fw-medium mb-1">
                                        Name
                                      </p>
                                      {GetstudentData?.guardian_name}
                                    </h6>
                                    <p className="text-primary">Guardian</p>
                                  </div>
                                </div>
                                )}
                                {GetstudentData?.guardian_mobile_no && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Phone
                                    </p>
                                    <p>
                                      {GetstudentData?.guardian_mobile_no}
                                    </p>
                                  </div>
                                </div>
                                )}
                                {GetstudentData?.guardian_relation && (
                                <div className="col-6  col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <h6 className="text-dark fw-medium mb-1">
                                      Relation
                                    </h6>
                                    <p>
                                      {GetstudentData?.guardian_relation}
                                    </p>
                                  </div>
                                </div>
                                )}
                                {GetstudentData?.guardian_email && (
                                <div className="col-12 col-sm-6 col-lg-4">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="mb-3 overflow-hidden me-3">
                                      <p className="text-dark fw-medium mb-1">
                                        Email
                                      </p>
                                      <p className="text-truncate">
                                        {GetstudentData?.guardian_email}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                )}
                                {GetstudentData?.guardian_aadhar_no && (
                                <div className="col-12 col-sm-6 col-lg-4">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="mb-3 overflow-hidden me-3">
                                      <p className="text-dark fw-medium mb-1">
                                        Aadhar Number
                                      </p>
                                      <p className="text-truncate">
                                        {GetstudentData?.guardian_aadhar_no}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                )}
                                {GetstudentData?.guardian_address && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="mb-3">
                                    <p className="text-dark fw-medium mb-1">
                                      Qualification
                                    </p>
                                    <p>
                                      {GetstudentData?.guardian_address}
                                    </p>
                                  </div>
                                </div>
                                )}
                                {GetstudentData?.guardian_occupation && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="mb-3 overflow-hidden me-3">
                                      <p className="text-dark fw-medium mb-1">
                                        Occupation
                                      </p>
                                      <p>
                                        {GetstudentData?.guardian_occupation}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                )}
                                {GetstudentData?.guardian_qualification && (
                                <div className="col-6 col-sm-6 col-lg-4">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="mb-3 overflow-hidden me-3">
                                      <p className="text-dark fw-medium mb-1">
                                        Qualification
                                      </p>
                                      <p>
                                        {GetstudentData?.guardian_qualification}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
           ) : null}
                    {/* /Guardian Information */}
                  </div>
                  
                
                </div>
              </div>
              </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="content row d-flex justify-content-center align-items-center background-color_row_1">
            {/* <Header /> */}
            <ImageWithBasePath
              src="assets/img/nodata.gif"
              className="img-fluid"
              alt="img"
              width={200}
            />
          </div>
        )}
      </div>
      {/* /Page Wrapper */}
      {/* <StudentModals /> */}
    </>
  );
};

export default StudentProfileView
